import { useCallback } from 'react';

export const useCancelPayment = (
  resetStartTime: () => void,
  removeCookieData: () => void,
  setIsRedirecting: (isRedirecting: boolean) => void,
  paymentPageUrl?: string,
) => {
  return useCallback(
    (errorMessage?: string) => {
      resetStartTime();
      removeCookieData();
      setIsRedirecting(true);

      if (paymentPageUrl) {
        if (errorMessage) {
          const url = new URL(paymentPageUrl, window.location.origin);
          url.searchParams.set('errorMessage', errorMessage);
          window.location.assign(url.toString());
        } else {
          window.location.assign(paymentPageUrl);
        }
        return;
      }

      window.history.back();
    },
    [resetStartTime, removeCookieData, setIsRedirecting, paymentPageUrl],
  );
};
